<h2 class="text-center text-md-left mt-4 mt-md-0">
  Buscar por region
  <small class="text-info" *ngIf="regionActiva"
    >"{{ regionActiva | titlecase }}"</small
  >
</h2>
<hr class="bg-info" />

<h5 class="mt-4 mb-3">Seleccione la region</h5>

<div class="row">
  <div class="col">
    <!-- [class.btn-success]="region === regionActiva" -->
    <!-- [ngClass]="{
        'btn-success': regionActiva === region,
        'btn-outline-success': regionActiva !== region
      }" -->
    <button
      *ngFor="let region of regiones"
      [class]="
        region === regionActiva ? 'btn btn-success' : 'btn btn-outline-success'
      "
      (click)="activarRegion(region)"
    >
      {{ region | titlecase }}
    </button>
  </div>
</div>

<p *ngIf="loading" class="alert alert-info">Cargando Paises...</p>

<div *ngIf="paises.length > 0" class="row">
  <div class="col">
    <app-pais-table [paises]="paises" class="table-responsive"></app-pais-table>
  </div>
</div>
